module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"image":"Image"}}')
  delete Component.options._Ctor
}
